import styled from '@emotion/styled';

import { mypageFormContainerCss, mypageSubmitAreaCss } from '@/components/MyPage/shared/subPageStyles';

export const FormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
	justify-content: center;
	${mypageFormContainerCss}
`;
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	align-items: center;
`;
export const ImgBox = styled.div`
	width: 11.8rem;
	img {
		width: 100%;
	}
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	align-items: center;
`;
export const Title = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export { NextButton } from '@/components/common/Button/style';
export const SubTitle = styled.p`
	text-align: center;
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
export const SecessionButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	color: #495057;
	height: 4rem;
	padding: 0 1.2rem;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	border: none;
	width: 100%;
	cursor: pointer;
	width: fit-content;
`;
export const ButtonBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	${mypageSubmitAreaCss}
	.button_wrap {
		display: flex;
		justify-content: center;
		width: 100%;
	}
`;
